export default {
  culture: "sv-SE",
  theme: "dark",
};
